/**
 * Legal document metadata shared between the /privacy and /terms pages and
 * anywhere else we cite an "Effective" date (signup checkbox tooltip, etc.).
 *
 * Bump both the version and effective date whenever the content materially
 * changes so the user's `terms_accepted_at` audit trail stays meaningful.
 */
export const LEGAL_VERSION = "2026-02-06a";
export const LEGAL_EFFECTIVE_DATE = "February 6, 2026";
export const SUPPORT_EMAIL = "support@theaminoexchange.com";
